"use client";

import RouteHighlights from "@/components/pages/flight/RouteHighlights";

export default function FlightRouteHighlightsClient({
  cheapestRoutes,
  title,
  airlineName,
  airlineUrl,
}) {
  const airlineSlug = cheapestRoutes?.AirlineSlug || null;
  const airportSlug = cheapestRoutes?.AirportSlug || null;

  return (
    <RouteHighlights
      cheapestRoutes={cheapestRoutes}
      title={title}
      airlineName={airlineName}
      airlineUrl={airlineUrl}
      airlineSlug={airlineSlug}
      airportSlug={airportSlug}
    />
  );
}
